import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SafeUrl } from '@angular/platform-browser';

import { PhotoPreviewComponent } from '../components/photo-preview/photo-preview.component';

@Injectable()
export class ImagesService {
  constructor(public dialog: MatDialog) {}

  openPhoto(url: string | ArrayBuffer | SafeUrl, title = 'image', errorOnLoad: boolean): void {
    if (url && !errorOnLoad) {
      this.dialog.open(PhotoPreviewComponent, {
        data: { url, title },
      });
    }
  }
}
